module.exports = __webpack_public_path__ + "static/media/ic_admin_hearing_set.75eb8cf2.svg";